import React from 'react';
import { Popover, Button } from 'react-bootstrap';
import {
    Circle,
    Clock,
    XCircle,
    CheckCircle2
} from 'lucide-react';

const STATUS_CONFIG = {
    'NOT_STARTED': { label: 'Not Started', icon: Circle, color: 'text-muted', variant: 'light' },
    'IN_PROGRESS': { label: 'In Progress', icon: Clock, color: 'text-primary', variant: 'primary' },
    'DONE': { label: 'Done', icon: CheckCircle2, color: 'text-success', variant: 'success' },
    'CANCELED': { label: 'Canceled', icon: XCircle, color: 'text-danger', variant: 'danger' }
};

const TaskStatusPopover = ({ task, taskStatuses = [], onUpdate, ...props }) => {
    const handleStatusChange = (status) => {
        if (onUpdate) {
            const updates = { statusId: status.id };

            // Logic to sync isCompleted flag
            if (status.is_completed && !task.is_completed) {
                updates.isCompleted = true;
            } else if (!status.is_completed && task.is_completed) {
                updates.isCompleted = false;
            }

            onUpdate(updates);
        }
        document.body.click();
    };

    // Helper to get icon
    const getIcon = (statusName) => {
        const upper = statusName ? statusName.toUpperCase().replace(' ', '_') : 'NOT_STARTED';
        // Try strict match or fallback
        let key = 'NOT_STARTED';
        if (STATUS_CONFIG[upper]) key = upper;

        // If not found, try heuristics? Or just default.
        // If status name contains "Done" or "Completed" -> check logic?
        // For now, rely on mapping known standard names.
        // If custom names exist, we default to Circle if unknown.

        return STATUS_CONFIG[key]?.icon || Circle;
    };

    return (
        <Popover id={`popover-status-${task.id}`} {...props}>
            <Popover.Header as="h3">Status</Popover.Header>
            <Popover.Body>
                <div className="d-flex flex-column gap-1">
                    {taskStatuses.length > 0 ? (
                        taskStatuses.sort((a, b) => a.position - b.position).map(status => {
                            const Icon = getIcon(status.name);
                            const isActive = task.status_id === status.id;
                            return (
                                <Button
                                    key={status.id}
                                    variant="light"
                                    size="sm"
                                    className={`text-start d-flex align-items-center gap-2 ${isActive ? 'bg-light border' : ''}`}
                                    onClick={() => handleStatusChange(status)}
                                >
                                    <Icon size={14} className={status.color} />
                                    <span>{status.name}</span>
                                </Button>
                            );
                        })
                    ) : (
                        <div className="text-muted small text-center p-2">No statuses found.</div>
                    )}
                </div>
            </Popover.Body>
        </Popover>
    );
};

export default TaskStatusPopover;
export { STATUS_CONFIG };
